import { User } from "../common/types/user";

export type IPushParams = [string, (string | object)?];

declare global {
    interface Window {
        _hsq: { push: (callParam: IPushParams) => void };
    }
}

function _hsq() {
    window._hsq = window._hsq || [];
    return window._hsq;
}

export function identify(user: User) {
    _hsq().push([
        "identify",
        {
            email: user.email,
            firstname: user.firstName,
            lastname: user.lastName,
            phone: user.phoneNumber ?? undefined,
            user_id: user.id,
        },
    ]);
}

export function pageView(path: string) {
    _hsq().push(["setPath", path]);
    _hsq().push(["trackPageView"]);
}
